import { useEffect, useState } from "react";
import { db, auth } from "../../../firebase";
import AddRecord from "../Modals/AddRecord";
import MonthlySalary from "../Modals/MonthlySalary";
import { useAuth } from "../../../contexts/AuthContext";

const UserSection = () => {
  const { userInfo, setUserInfo, finalmonthlySalary } = useAuth();
  const [isAddRecordOpen, setIsAddRecordOpen] = useState(false);
  const [isMonthlySalatyOpen, setIsMonthlySalatyOpen] = useState(false);
  const [greetingMsg, setGreetingMsg] = useState("");

  const capitalize = (str) =>
    str && str.slice(0, 1).toUpperCase() + str.slice(1);

  useEffect(() => {
    const day = new Date();
    const hour = day.getHours();
    if (hour > 0 && hour < 12) setGreetingMsg("Good Morning");
    else if (hour === 12) setGreetingMsg("Good Noon");
    else if (hour >= 12 && hour <= 17) setGreetingMsg("Good Afternoon");
    else setGreetingMsg("Good Evening");
  }, []);

  useEffect(() => {
    const userRef = db.users.doc(auth.currentUser.uid);
    userRef
      .get()
      .then((doc) => {
        if (doc.exists) {
          const data = doc.data();
          console.log("Document Data: ", data);
          setUserInfo(data);
        } else console.log("No Such Document");
      })
      .catch((error) => {
        console.log("Error getting document:", error);
      });
  }, [setUserInfo, finalmonthlySalary]);

  return (
    <>
      <div className="w-full h-28 flex items-center justify-between px-8 py-3 border-b-2 border-gray-100">
        <div className="flex items-center space-x-3">
          <img
            className="w-16 h-16 rounded-full object-cover object-top"
            src={userInfo?.imageURL}
            alt="Profile"
          />
          <div className="text-2xl font-bold text-gray-700">
            <h2>
              {`${greetingMsg}, ${capitalize(userInfo?.fname)} ${capitalize(
                userInfo?.lname
              )}`}
            </h2>
          </div>
        </div>

        <div className="flex space-x-2">
          <button
            onClick={() => setIsAddRecordOpen(true)}
            className="focus:outline-none hover:bg-gray-50 hover:border-gray-300 border-gray-200 font-medium text-sm border-2 px-4 py-2 rounded-lg text-gray-600 border-opacity-60"
          >
            Add Record
          </button>
          {userInfo?.isSalary && (
            <button
              onClick={() => setIsMonthlySalatyOpen(true)}
              className="focus:outline-none hover:bg-indigo-600 bg-indigo-700 font-medium px-4 py-2 rounded-lg text-white text-sm"
            >
              Monthly Salary
            </button>
          )}
        </div>
      </div>

      {isAddRecordOpen && (
        <AddRecord
          open={isAddRecordOpen}
          setOpen={setIsAddRecordOpen}
          userInfo={userInfo}
        />
      )}

      {isMonthlySalatyOpen && (
        <MonthlySalary
          open={isMonthlySalatyOpen}
          setOpen={setIsMonthlySalatyOpen}
          userInfo={userInfo}
        />
      )}
    </>
  );
};

export default UserSection;
